import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = {
  key: 1,
  src: "/media/icons/duotune/arrows/gifrep.gif",
  alt: "Loading Icon",
  class: "loading-icon"
}
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = { class: "row mb-12" }
const _hoisted_10 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-5" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-5" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-12" }
const _hoisted_19 = { class: "required col-lg-1 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-5 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "card-footer d-flex justify-content-center py-6 px-9" }
const _hoisted_24 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = { class: "indicator-progress" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('CustomerStatementReport')), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "svg-icon svg-icon-1 ms-6",
              style: {"cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
            }, [
              (!_ctx.loadingPage)
                ? (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 0,
                    src: "/media/icons/duotune/arrows/arr029.svg"
                  }))
                : _createCommentVNode("", true),
              (_ctx.loadingPage)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.print,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.translate('startDate')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "startDate",
                      autocomplete: "off",
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startDate) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          id: "startDate",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.startDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                          placeholder: _ctx.translate('dd/mm/yyyy'),
                          fieldId: "startDate",
                          reset: true
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "startDate" })
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.translate('endDate')), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "endDate",
                      autocomplete: "off",
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          id: "endDate",
                          class: "form-control form-control-lg form-control-solid",
                          modelValue: _ctx.endDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                          placeholder: _ctx.translate('dd/mm/yyyy'),
                          fieldId: "endDate",
                          reset: true
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "endDate" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate('customer')), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Field, {
                      name: "customerId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.selectedCustomer,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCustomer) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchField, {
                          modelValue: _ctx.selectedCustomer,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCustomer) = $event)),
                          options: _ctx.customers,
                          mode: "single",
                          label: _ctx.translate('Select Customer'),
                          className: "form-select-md"
                        }, null, 8, ["modelValue", "options", "label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "customerId" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('print')), 1),
                  _createElementVNode("span", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_27
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}